
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace('')
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as indexXHB6UaLwulMeta } from "/workspace/pages/business-unit/[id]/index.vue?macro=true";
import { default as campaignsRCn2lv5csiMeta } from "/workspace/pages/campaigns.vue?macro=true";
import { default as dashboardKIhr9Z9Xg1Meta } from "/workspace/pages/dashboard.vue?macro=true";
import { default as index9S03gOyIVcMeta } from "/workspace/pages/index.vue?macro=true";
import { default as _91integration_93D34IdEZi0FMeta } from "/workspace/pages/integrations/[integration].vue?macro=true";
import { default as clayAbChpmrJzLMeta } from "/workspace/pages/integrations/clay.vue?macro=true";
import { default as common_room9nsKeqTNmaMeta } from "/workspace/pages/integrations/common_room.vue?macro=true";
import { default as hockey_stackR5l2WK9UcMMeta } from "/workspace/pages/integrations/hockey_stack.vue?macro=true";
import { default as indexQMqNISckj4Meta } from "/workspace/pages/integrations/index.vue?macro=true";
import { default as linkedin_adsOmdJWC4KuNMeta } from "/workspace/pages/integrations/linkedin_ads.vue?macro=true";
import { default as meta_adsIzNMa20xBFMeta } from "/workspace/pages/integrations/meta_ads.vue?macro=true";
import { default as persanauYAOrhiKAuMeta } from "/workspace/pages/integrations/persana.vue?macro=true";
import { default as snapchat_adsUhApk7E48rMeta } from "/workspace/pages/integrations/snapchat_ads.vue?macro=true";
import { default as tapistrofrBfOmg1cxMeta } from "/workspace/pages/integrations/tapistro.vue?macro=true";
import { default as tiktok_adsD8wuKaGd5OMeta } from "/workspace/pages/integrations/tiktok_ads.vue?macro=true";
import { default as userledvxTxMVLR72Meta } from "/workspace/pages/integrations/userled.vue?macro=true";
import { default as webhook6Y3m2YH0YuMeta } from "/workspace/pages/integrations/webhook.vue?macro=true";
import { default as zapier3AQy3BUZssMeta } from "/workspace/pages/integrations/zapier.vue?macro=true";
import { default as indexgJzp5enSq0Meta } from "/workspace/pages/new-segments/[id]/index.vue?macro=true";
import { default as new_45visitor_45feedmciYZhEPsVMeta } from "/workspace/pages/new-visitor-feed.vue?macro=true";
import { default as indexKPvA6Vd01EMeta } from "/workspace/pages/onboarding/[step]/index.vue?macro=true";
import { default as indexuSdTzyeIibMeta } from "/workspace/pages/onboarding/index.vue?macro=true";
import { default as _91integration_93wPDEVIKoE4Meta } from "/workspace/pages/partner-integrations/[integration].vue?macro=true";
import { default as partnerrZtSmDXghUMeta } from "/workspace/pages/partner.vue?macro=true";
import { default as pixel_45settingstkFgbAZt0bMeta } from "/workspace/pages/pixel-settings.vue?macro=true";
import { default as ad_45revealJWHcFYjnIhMeta } from "/workspace/pages/reporting/ad-reveal.vue?macro=true";
import { default as traffic_45dnakjgTrdQ0b1Meta } from "/workspace/pages/reporting/traffic-dna.vue?macro=true";
import { default as indexQH1SGI6uaMMeta } from "/workspace/pages/segments/[id]/index.vue?macro=true";
import { default as account_45listsPgGun3ADazMeta } from "/workspace/pages/settings/account-lists.vue?macro=true";
import { default as billingI3k082VXU8Meta } from "/workspace/pages/settings/billing.vue?macro=true";
import { default as icpqfw7aoeaq6Meta } from "/workspace/pages/settings/icp.vue?macro=true";
import { default as index0NlQ4FDgWHMeta } from "/workspace/pages/settings/index.vue?macro=true";
import { default as intent_45topicsdfQNxt3bNZMeta } from "/workspace/pages/settings/intent-topics.vue?macro=true";
import { default as site_45pixel69Y4uoqaJIMeta } from "/workspace/pages/settings/site-pixel.vue?macro=true";
import { default as visitor_45feed243QXnfJSYMeta } from "/workspace/pages/visitor-feed.vue?macro=true";
import { default as indexAgAQwVgKmyMeta } from "/workspace/pages/visitor-segments/index.vue?macro=true";
export default [
  {
    name: "business-unit-id",
    path: "/business-unit/:id()",
    meta: indexXHB6UaLwulMeta || {},
    component: () => import("/workspace/pages/business-unit/[id]/index.vue")
  },
  {
    name: "campaigns",
    path: "/campaigns",
    meta: campaignsRCn2lv5csiMeta || {},
    component: () => import("/workspace/pages/campaigns.vue")
  },
  {
    name: "dashboard",
    path: "/dashboard",
    meta: dashboardKIhr9Z9Xg1Meta || {},
    component: () => import("/workspace/pages/dashboard.vue")
  },
  {
    name: "index",
    path: "/",
    meta: index9S03gOyIVcMeta || {},
    component: () => import("/workspace/pages/index.vue")
  },
  {
    name: "integrations-integration",
    path: "/integrations/:integration()",
    meta: _91integration_93D34IdEZi0FMeta || {},
    component: () => import("/workspace/pages/integrations/[integration].vue")
  },
  {
    name: "integrations-clay",
    path: "/integrations/clay",
    meta: clayAbChpmrJzLMeta || {},
    component: () => import("/workspace/pages/integrations/clay.vue")
  },
  {
    name: "integrations-common_room",
    path: "/integrations/common_room",
    component: () => import("/workspace/pages/integrations/common_room.vue")
  },
  {
    name: "integrations-hockey_stack",
    path: "/integrations/hockey_stack",
    meta: hockey_stackR5l2WK9UcMMeta || {},
    component: () => import("/workspace/pages/integrations/hockey_stack.vue")
  },
  {
    name: "integrations",
    path: "/integrations",
    meta: indexQMqNISckj4Meta || {},
    component: () => import("/workspace/pages/integrations/index.vue")
  },
  {
    name: "integrations-linkedin_ads",
    path: "/integrations/linkedin_ads",
    meta: linkedin_adsOmdJWC4KuNMeta || {},
    component: () => import("/workspace/pages/integrations/linkedin_ads.vue")
  },
  {
    name: "integrations-meta_ads",
    path: "/integrations/meta_ads",
    meta: meta_adsIzNMa20xBFMeta || {},
    component: () => import("/workspace/pages/integrations/meta_ads.vue")
  },
  {
    name: "integrations-persana",
    path: "/integrations/persana",
    meta: persanauYAOrhiKAuMeta || {},
    component: () => import("/workspace/pages/integrations/persana.vue")
  },
  {
    name: "integrations-snapchat_ads",
    path: "/integrations/snapchat_ads",
    meta: snapchat_adsUhApk7E48rMeta || {},
    component: () => import("/workspace/pages/integrations/snapchat_ads.vue")
  },
  {
    name: "integrations-tapistro",
    path: "/integrations/tapistro",
    meta: tapistrofrBfOmg1cxMeta || {},
    component: () => import("/workspace/pages/integrations/tapistro.vue")
  },
  {
    name: "integrations-tiktok_ads",
    path: "/integrations/tiktok_ads",
    meta: tiktok_adsD8wuKaGd5OMeta || {},
    component: () => import("/workspace/pages/integrations/tiktok_ads.vue")
  },
  {
    name: "integrations-userled",
    path: "/integrations/userled",
    component: () => import("/workspace/pages/integrations/userled.vue")
  },
  {
    name: "integrations-webhook",
    path: "/integrations/webhook",
    meta: webhook6Y3m2YH0YuMeta || {},
    component: () => import("/workspace/pages/integrations/webhook.vue")
  },
  {
    name: "integrations-zapier",
    path: "/integrations/zapier",
    meta: zapier3AQy3BUZssMeta || {},
    component: () => import("/workspace/pages/integrations/zapier.vue")
  },
  {
    name: "new-segments-id",
    path: "/new-segments/:id()",
    meta: indexgJzp5enSq0Meta || {},
    component: () => import("/workspace/pages/new-segments/[id]/index.vue")
  },
  {
    name: "new-visitor-feed",
    path: "/new-visitor-feed",
    meta: new_45visitor_45feedmciYZhEPsVMeta || {},
    component: () => import("/workspace/pages/new-visitor-feed.vue")
  },
  {
    name: "onboarding-step",
    path: "/onboarding/:step()",
    component: () => import("/workspace/pages/onboarding/[step]/index.vue")
  },
  {
    name: "onboarding",
    path: "/onboarding",
    component: () => import("/workspace/pages/onboarding/index.vue")
  },
  {
    name: "partner-integrations-integration",
    path: "/partner-integrations/:integration()",
    component: () => import("/workspace/pages/partner-integrations/[integration].vue")
  },
  {
    name: "partner",
    path: "/partner",
    meta: partnerrZtSmDXghUMeta || {},
    component: () => import("/workspace/pages/partner.vue")
  },
  {
    name: "pixel-settings",
    path: "/pixel-settings",
    meta: pixel_45settingstkFgbAZt0bMeta || {},
    component: () => import("/workspace/pages/pixel-settings.vue")
  },
  {
    name: "reporting-ad-reveal",
    path: "/reporting/ad-reveal",
    meta: ad_45revealJWHcFYjnIhMeta || {},
    component: () => import("/workspace/pages/reporting/ad-reveal.vue")
  },
  {
    name: "reporting-traffic-dna",
    path: "/reporting/traffic-dna",
    meta: traffic_45dnakjgTrdQ0b1Meta || {},
    component: () => import("/workspace/pages/reporting/traffic-dna.vue")
  },
  {
    name: "segments-id",
    path: "/segments/:id()",
    meta: indexQH1SGI6uaMMeta || {},
    component: () => import("/workspace/pages/segments/[id]/index.vue")
  },
  {
    name: "settings-account-lists",
    path: "/settings/account-lists",
    meta: account_45listsPgGun3ADazMeta || {},
    component: () => import("/workspace/pages/settings/account-lists.vue")
  },
  {
    name: "settings-billing",
    path: "/settings/billing",
    meta: billingI3k082VXU8Meta || {},
    component: () => import("/workspace/pages/settings/billing.vue")
  },
  {
    name: "settings-icp",
    path: "/settings/icp",
    meta: icpqfw7aoeaq6Meta || {},
    component: () => import("/workspace/pages/settings/icp.vue")
  },
  {
    name: "settings",
    path: "/settings",
    meta: index0NlQ4FDgWHMeta || {},
    component: () => import("/workspace/pages/settings/index.vue")
  },
  {
    name: "settings-intent-topics",
    path: "/settings/intent-topics",
    meta: intent_45topicsdfQNxt3bNZMeta || {},
    component: () => import("/workspace/pages/settings/intent-topics.vue")
  },
  {
    name: "settings-site-pixel",
    path: "/settings/site-pixel",
    meta: site_45pixel69Y4uoqaJIMeta || {},
    component: () => import("/workspace/pages/settings/site-pixel.vue")
  },
  {
    name: "visitor-feed",
    path: "/visitor-feed",
    meta: visitor_45feed243QXnfJSYMeta || {},
    component: () => import("/workspace/pages/visitor-feed.vue")
  },
  {
    name: "visitor-segments",
    path: "/visitor-segments",
    meta: indexAgAQwVgKmyMeta || {},
    component: () => import("/workspace/pages/visitor-segments/index.vue")
  }
]